<template>
  <div>
    <carousel
        id="index-carousel-dots"
        class="max-h-screen md:h-screen"
        :nav="false"
        :dots="true"
        :items="1"
    >
        <div
            class="hero hero-solar max-h-screen md:h-screen bg-gray-100 text-white text-center md:flex md:items-center"
        >
            <div class="container z-1 _xl">
                <div class="flex flex-col items-start text-left">
                    <h1 class="flex items-start font-bold text-left">
                        <figure>
                            <img src="/img/suprasolar/suprasolar.svg" />
                        </figure>
                    </h1>
                    <span class="block italic text-3xl max-w-lg mt-8">Projektiranje i implementacija fotonaponskih solarnih elektrana po najvišim standardima i modelu ključ u ruke</span>

                    <router-link
                        :to="{ name: 'suprasolar' }"
                        class="inline-block text-white hover:text-primary font-bold italic border-t-10 border-primary pt-4 mt-8"
                    >Vidi više</router-link>
                </div>
            </div>
        </div>
        <div
            class="hero hero-about max-h-screen md:h-screen bg-gray-100 text-white text-center md:flex md:items-center"
        >
            <div class="container z-1 _xl">
                <div class="flex flex-col items-start text-left">
                    <h1 class="flex items-start font-bold text-left">
                        <span>O nama</span>
                    </h1>
                    <span class="block italic text-3xl max-w-lg mt-8">Vaš specijalist za elektroenergetska i EKMI rješenja</span>

                    <router-link
                        :to="{ name: 'about' }"
                        class="inline-block text-white hover:text-primary font-bold italic border-t-10 border-primary pt-4 mt-8"
                    >Vidi više</router-link>
                </div>
            </div>
        </div>
        <div
            class="hero hero-projects max-h-screen md:h-screen bg-gray-100 text-white text-center md:flex md:items-center"
        >
            <div class="container z-1 _xl">
                <div class="flex flex-col items-start text-left">
                    <h1 class="flex items-start font-bold text-left">
                        <span>Projekti</span>
                    </h1>
                    <span class="block italic text-3xl max-w-lg mt-8">Naši projekti su rezultat predanosti, timskog rada i stručnosti našeg tima</span>

                    <router-link
                        :to="{ name: 'projects' }"
                        class="inline-block text-white hover:text-primary font-bold italic border-t-10 border-primary pt-4 mt-8"
                    >Vidi više</router-link>
                </div>
            </div>
        </div>
    </carousel>

    <div class="section bg-white text-secondary" :class="{ 'pb-0': ! _.isEmpty(projects) }">
      <div class="container _xl">
        <p
          class="italic text-xl md:text-2xl lg:text-3xl font-light md:max-w-md"
        >Naša rješenja i usluge kombinacija su vrhunske tehnologije i specifičnih znanja što potvrđuju i brojke:</p>

        <div class="flex flex-wrap text-center sm:text-left italic mt-8 lg:mt-16 xl:mt-32" v-scroll-reveal="{
          beforeReveal: allowCounting,
          afterReset: resetCounter,
          reset: true,
          }">
          <div class="w-full sm:w-1/3 has-hover-effect">
            <span class="block w-24 mx-auto sm:mx-0 sm:w-32 h-px bg-gray-200"></span>
            <animated-number :number="counter1.number" :allowCounting="this.allowCountingFlag"></animated-number>
            <p class="text-center sm:text-left font-light" v-text="counter1.title"></p>
          </div>
          <div class="w-full sm:w-1/3 mt-6 sm:mt-0 has-hover-effect">
            <span class="block w-24 mx-auto sm:mx-0 sm:w-32 h-px bg-gray-200"></span>
            <animated-number :number="counter2.number" :allowCounting="this.allowCountingFlag"></animated-number>
            <p class="text-center sm:text-left font-light" v-text="counter2.title"></p>
          </div>
          <div class="w-full sm:w-1/3 mt-6 sm:mt-0 has-hover-effect">
            <span class="block w-24 mx-auto sm:mx-0 sm:w-32 h-px bg-gray-200"></span>
            <animated-number :number="counter3.number" :allowCounting="this.allowCountingFlag"></animated-number>
            <p class="text-center sm:text-left font-light" v-text="counter3.title"></p>
          </div>
        </div>
      </div>
    </div>

    <template v-if="! _.isEmpty(projects)">
      <div class="projects-title section push-content bg-white text-secondary">
        <div class="container _xl" v-scroll-reveal>
          <h2 class="text-4xl lg:text-5xl xxl:text-6xl">Projekti</h2>
        </div>
      </div>
      <div class="projects section bg-gray-100 text-secondary">
        <div class="container _carousel pull-content">
          <carousel class="-ml-12 xl:ml-0 -mt-12" :nav="false" :dots="false" :responsive="carouselResponsive" @drag="dragIt" @dragged="draggedIt" v-scroll-reveal>
              <div v-for="(project, i) in projects" class="pl-12 xl:pr-12 xl:pl-0 pt-12" :key="`project-${i}`">
              <router-link
                tag="figure"
                :to="{ name: 'project', params: { slug: project.slug } }"
                class="carousel-image"
                :class="isDragging ? 'disable-link' : ''"
                :style="{
                  backgroundImage: `url(${project.card ? project.card : project.image})`,
                }"
              ></router-link>

              <router-link
                :to="{ name: 'project', params: { slug: project.slug } }"
                tag="h3"
                class="my-6"
                :class="isDragging ? 'disable-link' : ''"
                v-text="project.name"></router-link>

              <span class="block" v-text="project.services_list"></span>
              <span class="block" v-text="project.timeframe"></span>
            </div>
          </carousel>

          <router-link
            :to="{ name: 'projects' }"
            class="inline-block text-secondary hover:text-primary font-bold italic border-t-10 border-primary pt-4 mt-8 lg:mt-16"
          >Pogledaj sve projekte</router-link>
        </div>
      </div>
    </template>

    <template v-if="! _.isEmpty(services)">
      <div class="section">
        <div class="container _xl">
          <h2 class="text-4xl lg:text-5xl xxl:text-6xl mb-8 lg:mb-16" v-scroll-reveal>Usluge</h2>

          <div class="flex flex-wrap">
            <router-link
              v-for="(service, i) in services"
              :key="`service-${i}`"
              :to="service && service.route ?
                { name: service.route } :
                { name: 'service', params: { slug: service.slug } }
              "
              class="card cols p-10 bg-cover _overlay md:py-16 xl:pt-36 xl:pb-12"
              :class="[ (services.length % 2) !== 0 && i + 1 == services.length ? 'cols-full' : '' ]"
              :style="`background-image: url('${service.image}')`"
              v-scroll-reveal
            >
              <div class="card-body z-1">
                <h3 class="card-title">
                  <span class="text-white">{{ service.name }}</span>
                </h3>
                <p
                  class="leading-tight text-gray-300 italic my-4 xl:my-8"
                  v-if="service.description"
                  v-html="service.description"
                ></p>

                <span class="card-next">
                  <img src="/svg/next.svg" alt />
                </span>
              </div>
            </router-link>
          </div>

          <router-link
            :to="{ name: 'services' }"
            class="inline-block text-white hover:text-primary font-bold italic border-t-10 border-primary pt-4 mt-8 lg:mt-16"
          >Više o uslugama</router-link>
        </div>
      </div>
    </template>

    <div class="section bg-white text-secondary push-content">
      <div class="container _xl">
        <h2 class="text-4xl lg:text-5xl xxl:text-6xl" v-scroll-reveal>Supra Net</h2>

        <span class="block w-3/4 sm:w-32 h-px bg-gray-200 my-6 lg:my-12"></span>

        <div class="flex flex-wrap text-justify md:-mx-6 xl:-mx-12">
          <div class="w-full md:w-1/2 md:px-6 xl:px-12" v-scroll-reveal>
            <p class="font-light">Tvrtka Supra Net je jedna od vodećih tvrtki u regiji u segmentu projektiranja, implementacije i razvoja zahtjevnih elektroenergetskih i EKMI rješenja. </p>

            <p class="font-light">U svakodnevnom poslovanju radimo na primjeni inovativnih, sigurnih i pouzdanih infrastrukturnih rješenja što potvrđuje preko 1000 zadovoljnih korisnika u Hrvatskoj i regiji.</p>
            <p class="font-light">Iza nas je 20 godina uspješnog poslovanja te više od 1500 uspješno realiziranih projekata iza kojih stoje stručni zaposlenici naše tvrtke. Snježna kraljica, Advent u Zagrebu, Ultra festival u Splitu…samo su neki od projekata čiji nas organizatori s povjerenjem odabiru iz godine u godinu.</p>
          </div>

          <div class="w-full md:w-1/2 md:px-6 xl:px-12 mt-6 md:mt-0" v-scroll-reveal>
            <p class="font-light"> Od početka našeg poslovanja do danas instalirali smo više od 5 000 000 metara svjetlovodnih kabela, izveli preko 1 000 000 optičkih prespoja te više od 250 000 linkova strukturnog kabliranja.
            Svojim korisnicima nudimo vrhunske usluge i tehnologije kroz partnerstva s vodećim svjetskim proizvođačima telekomunikacijske opreme, kontinuirano pratimo najnovije trendove na tržištu te ih implementiramo u svoje poslovanje.
            Konstantno radimo na inovacijama, poboljšanjima i patentima što nam omogućava realizaciju projekata u ugovorenim rokovima uz korištenje kvalitetne opreme i najsuvremenijih alata te mjernih instrumenata. </p>
            <p class="font-light">
            Naša rješenja i usluge kombinacija su vrhunske tehnologije i specifičnih znanja. Kontinuirano osluškujemo tržište i radimo na razvoju novih proizvoda i usluga!</p>
          </div>
        </div>

        <h5
          class="font-normal text-xl md:text-2xl lg:text-3xl my-6 md:mt-12 xl:mt-24"
          v-scroll-reveal
        >Partneri</h5>

        <div class="flex items-center justify-between">
          <figure class="w-1/9 lg:w-1/9 flex justify-center mr-6" v-scroll-reveal>
            <a href="http://www.leviton.com/">
              <img class="w-full" src="/img/logos/supranet-leviton.png" alt="Leviton" />
            </a>
          </figure>
          <figure class="w-1/9 lg:w-1/9 flex justify-center mr-6" v-scroll-reveal>
            <a href="http://www.mercury.co.kr/en/">
              <img class="w-full" src="/img/logos/supranet-mercury.png" alt="Mercury" />
            </a>
          </figure>
          <figure class="w-1/9 lg:w-1/9 flex justify-center mr-6" v-scroll-reveal>
            <a href="https://new.abb.com/">
              <img class="w-full" src="/img/logos/supranet-abb.png" alt="ABB" />
            </a>
          </figure>
          <figure class="w-1/9 lg:w-1/9 flex justify-center mr-6" v-scroll-reveal>
            <a href="https://www.se.com/hr/hr/">
              <img class="w-full" src="/img/logos/supranet-schneider.png" alt="Schneider" />
            </a>
          </figure>
          <figure class="w-1/9 lg:w-1/9 flex justify-center mr-6" v-scroll-reveal>
            <a href="http://www.matrixcabling.com/">
              <img class="w-full" src="/img/logos/supranet-matrix.png" alt="Matrix" />
            </a>
          </figure>
          <figure class="w-1/9 lg:w-1/9 flex justify-center mr-6" v-scroll-reveal>
            <a href="http://www.telegartner.com/">
              <img class="w-full" src="/img/logos/supranet-telegartner.png" alt="Telegartner" />
            </a>
          </figure>
          <figure class="w-1/9 lg:w-1/9 flex justify-center" v-scroll-reveal>
           <a href="http://www.rittal.com/">
            <img class="w-full" src="/img/logos/supranet-rittal.png" alt="Rittal" />
          </a>
          </figure>
        </div>

        <router-link
          :to="{ name: 'about' }"
          class="inline-block text-secondary hover:text-primary font-bold italic border-t-10 border-primary pt-4 mt-8 lg:mt-16"
          v-scroll-reveal
        >Više o Supra Netu</router-link>
      </div>
    </div>

    <div class="section bg-gray-100 text-secondary">
      <div class="container _xl pull-content mb-12 lg:mb-20">
        <figure
          class="bg-cover w-full h-64 md:h-96 xl:h-128 xxl:h-152 fhd:h-176 mx-auto max-w-2xl xxl:max-w-3xl fhd:max-w-4xl"
          style="background-image: url('/img/home/naslovnica-storm-grupa.jpg')"
          v-scroll-reveal
        ></figure>
      </div>

      <div class="container _xl flex flex-col items-center" v-scroll-reveal>
        <h2 class="text-4xl lg:text-5xl xxl:text-6xl mb-8 lg:mb-16">STORM Grupa</h2>

        <p
          class="text-center font-light max-w-md mx-auto"
          v-scroll-reveal
        >Mi smo stručnjaci za najbolja tehnološka rješenja! Sinergijom suradnje i razmjene znanja među tvrtkama članicama Grupe nastavljamo biti pouzdan partner regionalnog gospodarstva, uz neprestano ulaganje u edukaciju zaposlenih i razvoj inovativnih informacijsko-komunikacijskih rješenja.</p>

        <figure class="flex justify-center my-8 lg:my-16" v-scroll-reveal>
          <img src="/svg/logos/storm-grupa-c.svg" class="w-32" alt="STORM Grupa" />
        </figure>

        <a
          href="https://www.stormgrupa.hr"
          target="_blank"
          class="inline-block text-secondary whitespace-no-wrap hover:text-primary font-bold italic border-t-10 border-primary pt-4 px-2 mx-auto"
          v-scroll-reveal
        >STORM Grupa</a>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import AnimatedNumber from '../partials/AnimatedNumber'

export default {
  components: {
    carousel,
    AnimatedNumber
  },

  data() {
    return {
      carouselResponsive: {
        0: {
          items: 1,
          stagePadding: 0
        },

        576: {
          items: 2,
          stagePadding: 100
        },

        992: {
          items: 2,
          stagePadding: 140
        },

        1440: {
          items: 2,
          stagePadding: 200
        }
      },

      counter1: {
        title: '',
        number: 0,
      },

      counter2: {
        title: '',
        number: 0,
      },

      counter3: {
        title: '',
        number: 0,
      },

      projects: [],
      services: [],

      isDragging: false,

      allowCountingFlag: false,
    };
  },

  mounted() {
    this.counter1 = {
      title: 'godina uspješnog poslovanja',
      number: 20,
    }
    this.counter2 = {
      title: 'zadovoljnih korisnika',
      number: 1000,
    }
    this.counter3 = {
      title: 'odrađenih projekata',
      number: 1500,
    }

    this.getProjects();
    this.getServices();
  },

  methods: {
    getProjects() {
      this.$http
        .get(`/projects`, {
          params: {
            total: 8
          }
        })
        .then(response => {
          if (!_.isEmpty(response.data.data)) {
            this.projects = response.data.data;
          }
        })
        .catch(error => {
          console.log(error);
          console.log(error.response);
        });
    },

    getServices() {
      this.$http
        .get(`/services`)
        .then(response => {
          if (!_.isEmpty(response.data.data)) {
            this.services = response.data.data;

            this.services.push({
              id: null,
              name: 'SupraSolar',
              description: 'Projektiranje i implementacija fotonaponskih solarnih elektrana po najvišim standardima i modelu ključ u ruke',
              image: '/img/services/suprasolar.jpg',
              route: 'suprasolar'
            })
          }
        })
        .catch(error => {
          console.log(error);
          console.log(error.response);
        });
    },

    dragIt() {
      this.isDragging = true
    },

    draggedIt() {
      this.isDragging = false
    },

    allowCounting() {
      this.allowCountingFlag = true;
    },

    resetCounter() {
      this.allowCountingFlag = false;
    },
  },

  metaInfo: {
    title: "Naslovnica",
    titleTemplate: 'Supra Net - to make IT simple',
    meta: [
      {
        vmid: "og:image",
        property: "og:image",
        content: "https://www.supranet.hr/img/home/supranet-index-cover.jpg"
      },
      {
          vmid: "description",
          name: "description",
          content: 'Tvrtka Supra Net je jedna od vodećih tvrtki u regiji u segmentu projektiranja, implementacije i razvoja zahtjevnih elektroenergetskih i EKMI rješenja.'
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: 'Tvrtka Supra Net je jedna od vodećih tvrtki u regiji u segmentu projektiranja, implementacije i razvoja zahtjevnih elektroenergetskih i EKMI rješenja.'
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          content: 'Tvrtka Supra Net je jedna od vodećih tvrtki u regiji u segmentu projektiranja, implementacije i razvoja zahtjevnih elektroenergetskih i EKMI rješenja.'
        },
    ]
  }
};
</script>
